import { render, staticRenderFns } from "./Backtospeisekarte.vue?vue&type=template&id=89a3997e&scoped=true"
import script from "./Backtospeisekarte.vue?vue&type=script&lang=js"
export * from "./Backtospeisekarte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a3997e",
  null
  
)

export default component.exports